<template>
  <button
    class="copy hover_op"
    @click="(is_copied = true), startTimer()"
    v-clipboard:copy="text"
    v-clipboard:error="onError"
  >
    <span :class="{ active: !is_copied }">Copy</span>
    <img
      src="@/assets/img/copy_icon.svg"
      alt=""
      :class="{ active: !is_copied }"
    />

    <span :class="{ active: is_copied }">Copied!</span>
    <img
      src="@/assets/img/copied_icon.svg"
      alt=""
      :class="{ active: is_copied }"
    />
  </button>
</template>

<script>
export default {
  props: {
    text: String,
  },

  data() {
    return {
      is_copied: false,
    };
  },

  methods: {
    onError: function (e) {
      this.$store.dispatch("onError", "Failed to copy texts");
    },

    startTimer() {
      setTimeout(() => {
        this.is_copied = false;
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
.copy {
  margin-right: 16px;
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  display: flex;
  align-items: center;

  @media all and (max-width: 767px) {
    margin-right: 0;
  }

  span {
    cursor: pointer;
    display: none;

    &.active {
      display: block;

      @media all and (max-width: 769px) {
        display: none;
      }
    }

    @media all and (max-width: 769px) {
      display: none;
    }
  }

  img {
    width: 22px;
    margin-left: 16px;
    display: none;

    @media all and (max-width: 767px) {
      margin-left: 0;
    }

    &.active {
      display: block;
    }
  }
}
</style>